import { FormProvider, useForm } from 'react-hook-form';
import { ContentHeader, FormContainer, Input } from '@app/shared';
import React, { useCallback } from 'react';
import { useAccountIdContext } from '../AccountIdContext';
import {
  useRefreshAlternateMinimumDueArrangements,
  useRemoveAlternateMinimumDueArrangement,
  useUpdateAlternateMinimumDueArrangement,
} from '@app/sdk';
import { Segment } from 'semantic-ui-react';

export function UpdateAlternativeMinimumDueForm({ alternateMinimumDue }: { alternateMinimumDue: any }) {
  const { accountId } = useAccountIdContext();
  const { mutate: updateAlternateMinimumDues, isPending: isEditPending } = useUpdateAlternateMinimumDueArrangement();
  const { mutate: removeAlternateMinimumDue } = useRemoveAlternateMinimumDueArrangement();
  const refreshAlternateMinimumDueArrangements = useRefreshAlternateMinimumDueArrangements();

  const submitUpdateAlternateMinimumDue = useCallback(
    (data) => {
      updateAlternateMinimumDues({
        accountId,
        arrangementId: alternateMinimumDue.arrangementId,
        amount: data.amount,
        startDate: data.startDate,
        endDate: data.endDate,
      });
      setTimeout(() => {
        refreshAlternateMinimumDueArrangements();
      }, 2000);
    },
    [accountId, alternateMinimumDue.arrangementId, refreshAlternateMinimumDueArrangements, updateAlternateMinimumDues]
  );

  const submitRemoveAlternateMinimumDue = useCallback(() => {
    removeAlternateMinimumDue({ accountId, arrangementId: alternateMinimumDue.arrangementId });
    setTimeout(() => {
      refreshAlternateMinimumDueArrangements();
    }, 2000);
  }, [accountId, alternateMinimumDue.arrangementId, refreshAlternateMinimumDueArrangements, removeAlternateMinimumDue]);

  const formContext = useForm<{ amount: number; arrangementId: string; startDate: string; endDate: string }>();
  return (
    <Segment>
      <ContentHeader>Update Alternate Minimum Due</ContentHeader>
      <FormProvider {...formContext}>
        <FormContainer
          isSubmitting={isEditPending}
          onSubmit={submitUpdateAlternateMinimumDue}
          additionalButtons={
            <button
              type="button"
              className="ui button red"
              onClick={submitRemoveAlternateMinimumDue}
              disabled={!!isEditPending || alternateMinimumDue?.status === 'Ended'}>
              <span>Remove</span>
            </button>
          }>
          <Input defaultValue={alternateMinimumDue?.amount} name={'amount'} label={'Amount'} />
          <Input
            defaultValue={alternateMinimumDue?.startDate}
            name={'startDate'}
            label={'Start Date'}
            placeholder={'Optional: yyyy-mm-dd'}
          />
          <Input
            defaultValue={alternateMinimumDue?.endDate}
            name={'endDate'}
            label={'End Date'}
            placeholder={'Optional: yyyy-mm-dd'}
          />
        </FormContainer>
      </FormProvider>
    </Segment>
  );
}
